import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useInvalidateUseGetAgencyInformationForUser } from '@urbanx/agx.agencies.client';
import { useStoreAccessCode } from '@urbanx/agx.rpdata.client';
import useQuery from 'hooks/useQuery';

const RpDataAuthenticated = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const invalidateAgencyInformation = useInvalidateUseGetAgencyInformationForUser();
  const { storeAccessCode } = useStoreAccessCode({
    onSuccess: async () => {
      await invalidateAgencyInformation();
      navigate('/onboarding', { replace: true });
    },
    onError: () => navigate('/onboarding?rpDataErrorCode=connection-failed', { replace: true }),
  });

  useEffect(() => {
    const code = query.get('code');

    if (!code) {
      navigate('/onboarding?rpDataErrorCode=authorization-failed', { replace: true });
      return;
    }

    void storeAccessCode({ code }).catch(() => undefined);
  }, [navigate, query, storeAccessCode]);

  return null;
};

export default RpDataAuthenticated;
